// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1CQTn","label":"SetPasswdForm_label__2PMpi"};